import React from 'react';
import {connect} from 'react-redux'

import {get as _get} from "lodash";
import * as actions from '../../../store/actions'


import Input from "../../theme/forms/Input";
import api from "../../../store/api";
import ConfirmModal from "../../theme/modals/ConfirmModal";
import AdminWrapper from "../../theme/wrappers/AdminWrapper";
import PublicTopNav from "../../theme/nav/PublicTopNav";
import BaseHomePageLogoWrapper from "../../theme/logoCards/baseHomePageLogoWrapper"

import {isUserLoggedIn} from "../../../utils/session/logout";
import {addErrorAlert, toggleGlobalLoader} from "../../../store/calls/alertLoadingDispatch";
import BaseModal from "../../theme/modals/BaseModal";
import MapFrame from "../../theme/maps/mapFrame";
import PacefiFullScreenSpinner from "../../theme/loaders/pacefiFullScreenSpinner";
// const themePath = path.resolve(__dirname, `../src/themes/${process.env.THEME_NAME}.js`);
import subdomainConfigs from '../../../subdomainStyles.json';
import LogoFooter from '../../theme/logoFooter/logo';
import {projectStartSearch} from "../../../utils/projectStartSearch"
import {getSubdomain} from "../../../utils/general";
import { pullSubdomainStyleFromCookie } from '../../../utils/subdomains/configHandlers';
import AlertFeed from "../../theme/alerts/alertFeed";
import formatters from '../../../utils/forms/formatters';

class DynamicHomePage extends React.Component {


    constructor(props) {
        super(props);

        this.state = {
            property_address_value: null,
            error: null,
            displayMap: false,
            showOnlyProgramsWithFunders: true,
            newsItems: [],
        }

        // working default
        this.defaultGeojson = {
            "type": "FeatureCollection",
            "features": [
                {
                    "type": "feature",
                    "geometry": {
                        "type": "MultiPolygon",
                        "coordinates": []
                    }
                }
            ]
        }

        this.mapGeojson = this.defaultGeojson;
        this.subdomain = getSubdomain();

    }

    parseNewsString = (val) => {
        if (!val || typeof val !== 'string') return [];
      
        // Normaliza y quita comillas envolventes si las hay
        let s = val.trim();
        if (s.startsWith('"') && s.endsWith('"')) {
          s = s.slice(1, -1);
        }
      
        // "Texto|URL|Fecha; Texto2|URL2|Fecha2; Solo texto|"
        const parts = s.split(';').map(p => p.trim()).filter(Boolean);
      
        return parts.map(part => {
          const pieces = part.split('|').map(p => p.trim());
          let text = '';
          let url  = '';
          let date = '';

          if (pieces.length === 1) {
            if (/^https?:\/\//i.test(pieces[0])) {
              url = pieces[0];
            } else {
              text = pieces[0];
            }
          } else if (pieces.length === 2) {
            text = pieces[0];
            url  = pieces[1];
          } else {
            text = pieces[0];
            url  = pieces[1];
            date = pieces[2];
          }
      
          // Clean escaped quotes e.g. \"Unblock\" -> "Unblock"
          text = text.replace(/\\"/g, '"');
          // Si no hay URL válida, la dejamos vacía; el render decide si hace <a> o <div>
          const looksLikeUrl = /^https?:\/\//i.test(url);
          return { text, url: looksLikeUrl ? url : '', date };
        });
    };

    extractBlogSlug = (url) => {
        if (!url || typeof url !== 'string') return null;
        try {
            const parsedUrl = new URL(url);
            if (parsedUrl.hostname.includes('blog.cleanfi.com')) {
                const parts = parsedUrl.pathname.split('/').filter(Boolean);
                return parts[parts.length - 1] || null;
            }
        } catch (e) {
            const match = url.match(/blog\.cleanfi\.com\/([^/?#]+)/);
            if (match) return match[1];
        }
        return null;
    };

    fetchDateForNewsItem = async (item) => {
        if (item.date) return item;
        const slug = this.extractBlogSlug(item.url);
        if (!slug) return item;

        try {
            const res = await fetch(`https://blog.cleanfi.com/wp-json/wp/v2/posts?slug=${encodeURIComponent(slug)}`);
            if (res.ok) {
                const posts = await res.json();
                if (Array.isArray(posts) && posts.length > 0) {
                    const postDate = posts[0].date || posts[0].date_gmt || posts[0].yoast_head_json?.article_published_time;
                    if (postDate) {
                        return { ...item, date: postDate };
                    }
                }
            }
        } catch (e) {
            // Silently ignore blog fetch errors
        }
        return item;
    };

    enrichAndFilterNews = async (items) => {
        const enrichedItems = await Promise.all(items.map(item => this.fetchDateForNewsItem(item)));
        return this.filterExpiredNews(enrichedItems);
    };

    filterExpiredNews = (items) => {
        const EXPIRATION_DAYS = 45;
        const now = new Date();

        return items.filter(item => {
            if (!item.date) return true; // Keep items without a date

            const newsDate = new Date(item.date.includes('T') ? item.date : `${item.date}T00:00:00`);
            if (isNaN(newsDate.getTime())) return true; // Keep items with unparseable dates

            const diffTime = now.getTime() - newsDate.getTime();
            const diffDays = diffTime / (1000 * 60 * 60 * 24);
            return diffDays <= EXPIRATION_DAYS;
        });
    };

    async componentDidMount() {
        toggleGlobalLoader(false);
    
        try {
          const url = `https://api.cleanfi.com/get-cleanfi-widget-admin-config/?subdomain=${encodeURIComponent(this.subdomain || 'app')}&_=${Date.now()}`;
          const res = await fetch(url, { credentials: 'omit' });
          const text = await res.text();
          const parsed = this.parseNewsString(text);
          const fromFeed = await this.enrichAndFilterNews(parsed);
    
          if (fromFeed.length) {
            this.setState({ newsItems: fromFeed });
            return;
          }
        } catch (e) {
          // Silently fail and fallback to config
        }
    
        // Fallback: try to get from config if exists
        const subdomainConfig = { ...subdomainConfigs.default, ...pullSubdomainStyleFromCookie() };
        const parsed = this.parseNewsString(subdomainConfig['news-links']);
        const cfg = await this.enrichAndFilterNews(parsed);
        if (cfg.length) this.setState({ newsItems: cfg });
      }


    handleAddressFormSubmit = synEvent => {
        synEvent.preventDefault();
        projectStartSearch(this.state.property_address_value, this.props.history)
    }


    loadAndOpenMap = () => {
        toggleGlobalLoader(true);

        api.get('/country-geojson/', {wfunders: this.state.showOnlyProgramsWithFunders ? 1 : null})
            .then(res => {
                this.mapGeojson = res.data;
                this.setState({displayMap: false}, () => this.setState({displayMap: true})); // off before on as security and to ensure update
            })
            .catch(err => addErrorAlert("Something's not right. We had a problem getting the map data."))
            .finally(() => toggleGlobalLoader(false))
    };

    closeAndClearMap = () => {
        this.setState({displayMap: false})
    }


    render() {
        const subdomainConfig = { ...subdomainConfigs.default, ...pullSubdomainStyleFromCookie() };

        // Prymary color fallback
        const primaryColor =
        subdomainConfig['primary-color'] ||
        subdomainConfig.primaryColor ||
        '#3273dc';
    
        return (
          <div id="homepage-wrapper">
            <section className="hero is-fullheight" id="homepage_bg">
              <PublicTopNav navbarClass="" />
    
              <div className="hero-body">
                <div className="container is-flex is-justify-content-center has-text-centered" style={{maxWidth: '1000px'}}>
                  <div className="p-6 has-background-white-bis-transparent">
                    <h2 className="subtitle has-text-primary mb-3 is-size-1 is-size-4-mobile">
                      {subdomainConfig['homepage-title']}
                    </h2>
                    <h1 className="subtitle has-text-primary mb-6 is-size-5-mobile">
                      {subdomainConfig['homepage-subtitle']}
                    </h1>
    
                    {/* Form */}
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                      <div>
                        <form onSubmit={this.handleAddressFormSubmit} className="is-flex is-flex-wrap-wrap">
                          <div className="mr-2">
                            <Input
                              type="text"
                              placeholder="Enter property address"
                              value={this.state.property_address_value}
                              inputClasses="is-large input"
                              onChange={val => this.setState({ property_address_value: val, property_address_error: false })}
                            />
                          </div>
                          <div className="">
                            <button type='submit' className="button is-link is-large">
                              Start Your Project
                            </button>
                          </div>
                        </form>
                      </div>
                      <div className="input-error has-text-danger" style={{opacity: this.state.error ? 1 : 0}}>
                        {this.state.error || ''}
                      </div>
                    </div>
    
                    {/* News (if there is any) */}
                    {this.state.newsItems.length > 0 && (
                    <div
                        className="box mt-6"
                        style={{
                        textAlign: 'left',
                        borderRadius: 0,                 
                        background: '#fff',
                        borderColor: 'hsl(0deg, 0%, 86%)',
                        boxShadow: '0 2px 12px rgba(0,0,0,.04)',
                        }}
                    >
                    {/* Container: showing max 2; greater than 2, scroll */}
                    {(() => {
                    const needsScroll = this.state.newsItems.length >= 2; // 2 or more ⇒ scroll
                    // aprox height for 2 items:
                    const twoItemsHeight = '160px';

                    return (
                        <div
                        style={{
                            maxHeight: needsScroll ? twoItemsHeight : 'none',
                            overflowY: needsScroll ? 'auto' : 'visible',
                            paddingRight: needsScroll ? 4 : 0,
                        }}
                        >
                        <style>{`
                            .cf-news-scroll::-webkit-scrollbar { width: 6px; }
                            .cf-news-scroll::-webkit-scrollbar-thumb {
                            background: ${primaryColor}33;
                            border-radius: 8px;
                            }
                            .cf-news-scroll::-webkit-scrollbar-track { background: transparent; }
                        `}</style>

                        <ul className="cf-news-scroll" style={{ listStyle: 'none', paddingLeft: 0, margin: 0 }}>
                            {this.state.newsItems.map((n, idx) => {
                            const hasUrl = !!(n.url && n.url.trim());
                            const ContentTag = hasUrl ? 'a' : 'div';
                            const baseItemStyle = {
                                display: 'flex',
                                alignItems: 'center',
                                gap: '.6rem',
                                textDecoration: 'none',
                                color: primaryColor,
                                fontWeight: 500,
                                padding: '0.65rem 0.9rem',
                            };

                            const contentProps = hasUrl
                                ? { href: n.url, target: '_blank', rel: 'noopener noreferrer', style: baseItemStyle }
                                : { style: { ...baseItemStyle, cursor: 'default' }, role: 'text' };

                            const formattedDate = n.date ? formatters.date('iso', 'MMM d, yyyy').formatter(n.date) : null;
                            const displayDate = formattedDate && formattedDate !== '~' ? formattedDate : n.date;

                            return (
                                <li
                                key={`${(n.text || 'news').slice(0, 50)}-${idx}`}
                                style={{
                                    border: `1px solid ${primaryColor}33`,
                                    borderRadius: 0,
                                    marginBottom: '.6rem',
                                    transition: 'box-shadow .15s ease, transform .08s ease',
                                    background: '#fff',
                                    position: 'relative',
                                }}
                                onMouseEnter={e => {
                                    e.currentTarget.style.boxShadow = '0 6px 16px rgba(0,0,0,.06)';
                                    e.currentTarget.style.transform = 'translateY(-1px)';
                                }}
                                onMouseLeave={e => {
                                    e.currentTarget.style.boxShadow = 'none';
                                    e.currentTarget.style.transform = 'none';
                                }}
                                >
                                <ContentTag {...contentProps}>
                                    <span
                                    style={{
                                        fontSize: '0.7rem',
                                        fontWeight: 700,
                                        padding: '.18rem .5rem',
                                        background: `${primaryColor}14`,
                                        color: primaryColor,
                                        border: `1px solid ${primaryColor}33`,
                                        borderRadius: 0,
                                        textTransform: 'uppercase',
                                        letterSpacing: '0.03em',
                                        flexShrink: 0,
                                    }}
                                    >
                                    News
                                    </span>

                                    <span
                                    style={{
                                        flex: 1,
                                        whiteSpace: 'nowrap',
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                    }}
                                    title={n.text || n.url || 'Update'}
                                    >
                                    {n.text || n.url || 'Update'}
                                    {displayDate ? (
                                        <span
                                            style={{
                                                fontSize: '0.8rem',
                                                color: '#7a7a7a',
                                                fontWeight: 400,
                                                marginLeft: '0.5rem',
                                            }}
                                        >
                                            ({displayDate})
                                        </span>
                                    ) : null}
                                    </span>

                                    {hasUrl && (
                                    <svg
                                        width="16" height="16" viewBox="0 0 24 24" fill="none"
                                        stroke={primaryColor} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
                                        style={{ flexShrink: 0 }}
                                        aria-hidden="true"
                                    >
                                        <path d="M9 18l6-6-6-6" />
                                    </svg>
                                    )}
                                </ContentTag>
                                </li>
                            );
                            })}
                        </ul>
                        </div>
                    );
                    })()}    
                    </div>
                    )}
    
                    <span className="mt-3">
                      <LogoFooter/>
                    </span>
                    <BaseHomePageLogoWrapper/>
                  </div>
                </div>
              </div>
            </section>
    
            <div id="admin-wrapper-alert-feed">
              <AlertFeed/>
            </div>
            <PacefiFullScreenSpinner/>
          </div>
        );
      }
}


const mapStateToProps = state => ({
    subdomainInfo: state.session.subdomainInfo,
})

const mapDispatchToProps = dispatch => ({
    updateProjectInputs: data => dispatch(actions.formFlow.updateFormFlowInputs(data)),
    updateProjectComputed: data => dispatch(actions.formFlow.updateFormFlowComputed(data)),
    clearFormFlow: data => dispatch(actions.formFlow.clearFormFlow()),
    setFocusedProject: data => dispatch(actions.projectLeads.setFocusedProject()),
    updateInfoFeedDisplay: data => dispatch(actions.infoFeed.updateInfoFeedDisplay(data)),
    clearInfoFeedDisplay: data => dispatch(actions.infoFeed.clearInfoFeedDisplay()),
})


export default connect(mapStateToProps, mapDispatchToProps)(DynamicHomePage)



